"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
var Permission;
(function (Permission) {
    Permission["ADD_SUPER_USER"] = "add_super_user";
    Permission["DELETE_SUPER_USER"] = "delete_super_user";
    Permission["CREATE_GROUP"] = "create_group";
    Permission["RENAME_GROUP"] = "rename_group";
    Permission["DELETE_GROUP"] = "delete_group";
    Permission["CREATE_STATUS"] = "create_status";
    Permission["RENAME_STATUS"] = "rename_status";
    Permission["DELETE_STATUS"] = "delete_status";
    Permission["INVITE_USER_TO_GROUP"] = "invite_user_to_group";
    Permission["REMOVE_USER_FROM_GROUP"] = "remove_user_from_group";
    Permission["EDIT_USER_INFO"] = "edit_user_info";
    Permission["ASSIGN_TASK"] = "assign_task";
    Permission["CANCEL_TASK"] = "cancel_task";
    Permission["EDIT_USER_PERMISSIONS"] = "edit_user_permissions";
    Permission["CREATE_THEME"] = "create_theme";
    Permission["RENAME_THEME"] = "rename_theme";
    Permission["DELETE_THEME"] = "delete_theme";
    Permission["CREATE_FOLDER"] = "create_folder";
    Permission["RENAME_FOLDER"] = "rename_folder";
    Permission["DELETE_FOLDER"] = "delete_folder";
    Permission["ADD_DOCUMENT"] = "add_document";
    Permission["RENAME_DOCUMENT"] = "rename_document";
    Permission["DELETE_DOCUMENT"] = "delete_document";
    Permission["VIEW_DIFFUSING_DOCUMENT"] = "view_diffusing_document";
    Permission["VIEW_OLD_DOCUMENT_VERSION"] = "view_old_document_version";
    Permission["VALIDATE_DOCUMENT"] = "validate_document";
    Permission["SEND_FOR_VALIDATION"] = "send_for_validation";
    Permission["DIFFUSE_DOCUMENT"] = "diffuse_document";
    Permission["UPLOAD_NEW_VERSION"] = "upload_new_version";
    Permission["ARCHIVE_DOCUMENT"] = "archive_document";
    Permission["TRANSFER_SUPER_ADMIN_RIGHTS"] = "transfer_super_admin_rights";
    Permission["VIEW_PERSONAL_INFO"] = "view_personal_info";
    Permission["EDIT_PERSONAL_INFO"] = "edit_personal_info";
    Permission["VIEW_COMPANY_INFO"] = "view_company_info";
    Permission["EDIT_COMPANY_INFO"] = "edit_company_info";
    Permission["VIEW_SUBSCRIPTION"] = "view_subscription";
    Permission["EDIT_SUBSCRIPTION"] = "edit_subscription";
    Permission["VIEW_PREFERENCES"] = "view_preferences";
    Permission["EDIT_PREFERENCES"] = "edit_preferences";
    Permission["VIEW_LEGAL_INFO"] = "view_legal_info";
    Permission["VIEW_PERFORMANCE_DASHBOARD"] = "view_performance_dashboard";
    Permission["VIEW_ADMIN_BANNER"] = "view_admin_banner";
    Permission["VIEW_PROFILE_TASKS"] = "view_profile_tasks";
    Permission["VIEW_PROFILE_DOCUMENTS"] = "view_profile_documents";
    Permission["SWITCH_COMPANY"] = "switch_company";
    Permission["ADD_COMPANY"] = "add_company";
    Permission["DELETE_COMPANY"] = "delete_company";
    Permission["VIEW_DASHBOARD"] = "view_dashboard";
    Permission["VIEW_MY_DOCUMENTS"] = "view_my_documents";
    Permission["VIEW_MY_TASKS"] = "view_my_tasks";
    Permission["VIEW_MY_COMPANIES"] = "view_my_companies";
    Permission["VIEW_USER_MANAGEMENT"] = "view_user_management";
})(Permission || (exports.Permission = Permission = {}));
//# sourceMappingURL=permission.enum.js.map